import PropTypes from 'prop-types';
import React from 'react';

import NormalButton from '../../atoms/NormalButton';

class CancelDeactivateButton extends React.Component {
  static get propTypes() {
    return {
      children: PropTypes.any,
      onClick: PropTypes.func,
    };
  }

  render() {
    return (
      <NormalButton color="danger" onClick={this.props.onClick}>
        解除
      </NormalButton>
    );
  }
}

export default CancelDeactivateButton;
